@let loading = loading$ | async;

<!-- SIDE PANEL CONTAINER - Wraps entire layout -->
<mat-sidenav-container [autosize]="sidenavSettings.autosize" [hasBackdrop]="sidenavSettings.hasBackdrop" (backdropClick)="sidenavClose()" disableClose class="main-sidenav-container">
  <!-- SIDE PANEL -->
  <mat-sidenav (keydown.escape)="sidenavClose()" class="side-panel" [ngClass]="sidenavSettings.size" [class.no-backdrop]="!sidenavSettings.hasBackdrop" [mode]="sidenavSettings.mode" disableClose position="end">
    <!-- Resize handle -->
    @if (sidenavSettings.resizable) {
      <div class="resize-handle" title="Drag to resize" (mousedown)="startResizing($event)" [class.resizing]="resizingEvent.isResizing"></div>
    }
    <!-- Side panel content -->
    @if (loading) {
      <shared-local-dot-loader class="local-loading" />
    }
    @if (sidenavSettings.hasCloseButton || deviceType === DeviceType.phone) {
      <button type="button" svgIcon="close" class="btn btn-icon-only sidenav-close-button" (click)="sidenavClose()"></button>
    }
    <ng-container #sidepanelContent></ng-container>
  </mat-sidenav>

  <!-- MAIN CONTENT -->
  <mat-sidenav-content id="main-sidenav-content">
    <div class="main" [attr.theme-layout]="themeLayout" [attr.device-type]="deviceType" [attr.layout-type]="layoutType" (window:resize)="onResize($event)">
      <app-loading-screen />
      @if (!isSidenavOpen && loading) {
        <shared-custom-loader />
      }

      <div class="main-container">
        <app-menu></app-menu>
        <div class="main-body">
          <app-alert-bar />
          @if (showBreadcrumb) {
            <app-breadcrumbs />
          }
          <div class="page-wrapper">
            <router-outlet />
          </div>
        </div>
      </div>
    </div>
  </mat-sidenav-content>
</mat-sidenav-container>

<app-upload-processing />
@if (aiAgentEnabled && !isSidenavOpen) {
  <!-- Chat button - always visible when panel is closed -->
  <div class="chat chat-btn" (click)="openChatPanel()"><svg-icon key="chat" size="xl" /></div>
}
